/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */

/**
 * Comparison operator
 */
export type FilterItemDtoOperator = (typeof FilterItemDtoOperator)[keyof typeof FilterItemDtoOperator];

export const FilterItemDtoOperator = {
  EQUALS: 'equals',
  NOT: 'not',
  AFTER: 'after',
  BEFORE: 'before',
  ONORAFTER: 'onOrAfter',
  ONORBEFORE: 'onOrBefore',
  CONTAINS: 'contains',
  STARTSWITH: 'startsWith',
  ENDSWITH: 'endsWith',
  ISEMPTY: 'isEmpty',
  ISNOTEMPTY: 'isNotEmpty',
  ISANYOF: 'isAnyOf',
} as const;
